

<template>
  <div>

    <b-card no-body>

      <b-card-body>
        <b-row>
          <b-col xl="12">
            <vue-apex-charts ref="barChart" style="direction:ltr"
              v-if="labels_data != undefined && labels_data.length != 0" type="bar"
             :options="apexChatData.lineChartSimple.chartOptions"
              :series="barSeries" :labels_data="labels_data"
             
               />
               <!-- :height="chartHeight(labels_data.length)" -->
          </b-col>
        </b-row>    
      </b-card-body>
    </b-card>
    <b-modal v-model="show" :title="modalTitle" title-tag="div">
      <div v-if="exportLoading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
 
      <table-widget :items="modalData" :fields="fields" :title="modalTitle" />
      <b-container fluid>

        <br />
      </b-container>
      <b-row style="justify-content: space-between;">

      
          <b-button v-if="title != 'Contrcats'" @click="exportData(title, 'pdf', modalData)" type="button"
            variant="primary" class="mr-1 ">
            {{ $t('Export PDF') }}
          </b-button>
        
       
          <b-button v-if="title != 'Contrcats'" @click="exportData(title, 'xlsx', modalData)" type="button"
            variant="primary" class="mr-1 pull-left">
            {{ $t('Export Excel') }}
          </b-button>
        
      </b-row>
    </b-modal>

  </div>
</template>

<script>

import { $themeColors } from '@themeConfig'

import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BBadge, BRow,
  BCol, BContainer, BButton
} from 'bootstrap-vue'

import { ref, computed } from '@vue/composition-api'

import VueApexCharts from 'vue-apexcharts'
import formsTables from '@/router/routes/forms-tables'
import store from '@/store'
import TableWidget from '@/views/dashboard/modals/TableWidget.vue';

import axios from '@/libs/axios'
import { OrbitSpinner } from 'epic-spinners'
export default {

  props: ['listData', 'barSeries', 'title', 'labels_data', 'widgetLabels','exportListType'],
  components: {
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BRow,
    BCol,
    BContainer,
    BButton,

    OrbitSpinner,
    TableWidget,
  },

  setup(props) {
    const show = ref(false);
    const modalData = ref([]);
    const modalTitle = ref("")
    const exportLoading=ref(false)
    const contractIndex=ref(0)
    const setModalData = (index) => {
      modalData.value = props.listData[index]
      if(modalData.value != undefined){
        show.value = true;
        modalTitle.value = Array.isArray(props.labels_data[index]) ? props.labels_data[index].join() : props.labels_data[index]
        contractIndex.value=index;
      }
    }


    const exportData = (listType, exportType, data) => {
      const d = new Date();
      let cdate = d.getFullYear() + "-" +
        ("00" + (d.getMonth() + 1)).slice(-2) + "-" +
        ("00" + d.getDate()).slice(-2) + " " +
        ("00" + d.getHours()).slice(-2) + ":" +
        ("00" + d.getMinutes()).slice(-2) + ":" +
        ("00" + d.getSeconds()).slice(-2)
        const postedData ={
            "exporter":exportType,
            "export":props.exportListType ,
            "contractIndex":contractIndex.value        
        }   

     return new Promise((resolve, reject) => {
         exportLoading.value=true
          axios.post(`export/`, postedData, {
          responseType: 'blob'
        })
          .then(response => {
            resolve(response.data)
            const type = response.headers['content-type']
            const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'file' + cdate + '.' + exportType
            link.click()
            exportLoading.value=false
          })
          .catch(reason => {exportLoading.value=false})
      })    }

    return {
      setModalData,
      show,
      modalData,
      modalTitle,
      contractIndex,
      exportData,
      exportLoading
    }
  },

  methods: {
    wordSize(word) {
      if (word.length < 15)
        return 1;
      return 2;
    },
    breakWords(array) {
      let out = []
      array.forEach((item, index) => {
        let s = item
        var result = [];
        var words = s.split(" ");
        var row = [];
        for (var i = 0; i < words.length; ++i) {
          if (row.reduce((s, w) => s + this.wordSize(w), 0) + this.wordSize(words[i]) >= 4) {
            result.push(row);
            row = [];
          }
          row.push(words[i]);
        }
        result.push(row);

        result = result.map(a => a.join(" "))

        array[index] = result;
      })

      return array
    },



    chartHeight(count) {
      if (count <= 2) {
        return 200;
      }
      return count * 60;

    }

  },
  updated: function () {
    if (this.$refs.barChart != undefined) {
      this.$refs.barChart.updateOptions({
        xaxis: {
          //categories: this.breakWords( this.labels_data),

        },
        legend: {
          customLegendItems: [this.$t(this.widgetLabels.planned), this.$t(this.widgetLabels.served), this.$t(this.widgetLabels.complection)]
        }
      })
    }
  },
  



  data() {
    return {
      // modalData:[],
      fields: [
        { "key": "id", "label": this.$t("id") },
        { "key": "name", "label": this.$t("Name") },
        { "key": "planned", "label": this.$t("Planned") },
        { "key": "served", "label": this.$t("Served") }
      ],

      apexChatData: {

        lineChartSimple: {

          chartOptions: {
            style: {

              diraction: 'ltr'
            },

            legend: {
              show: true,
              position: 'top',
              fontSize: '0.5rem',
              fontFamily: 'Montserrat',
              customLegendItems: [this.$t(this.widgetLabels.planned), this.$t(this.widgetLabels.served), this.$t(this.widgetLabels.complection)]
            },
            chart: {

              events: {
                dataPointSelection: (event, chartContext, config) => {
                  this.setModalData(config.dataPointIndex)
                }
              },
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: false,
              },
            },
            markers: {
              strokeWidth: 2,
              strokeOpacity: 1,
              strokeColors: [$themeColors.light],
              colors: [$themeColors.light],
            },
            colors: ['#00cce5', $themeColors.primary, '#f1cbff'],
            plotOptions: {
              bar: {
                horizontal: false,
                barHeight: '75%',
                endingShape: 'rounded',

              },
            },
           
            dataLabels: {
              enabled: true,
              formatter: function (val, opt) {

                if (opt.seriesIndex == 2) {
                  return val + '%'
                }
                return val
              },


            },
            stroke: {
              curve: 'straight',
            },
            grid: {
              xaxis: {



                lines: {
                  show: true,
                },
              },
            },
            tooltip: {
              custom(data) {
                return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
                  }</span></div>`
              },
            },
            xaxis: {

              categories: this.labels_data.length > 0 ? this.breakWords(this.labels_data) : [],
              //   categories: this.labels_data.length > 0 ? this.labels_data : [],

              opposite: true,

              labels: {
                show: true,
                trim: true,
              }

            },
            yaxis: {
              //opposite:true

              labels: {
                show: true,
                trim: true,
                style: {
                  colors: [],
                  fontSize: '12px',
                  minWidth: '500px !important',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 'bold',
                  cssClass: 'apexcharts-xaxis-label',
                },

              }

            },
          },
        },
      }
    }
  },
}
</script>


<style scoped>
.apexcharts-canvas {

  direction: ltr !important;
}

.apexcharts-datalabel {
  font-family: "Montserrat", Helvetica, Arial, serif !important;
  fill: #6e6b7b;
  font-weight: 700 !important;
}
</style>
